export default {
  fluidClassID: { field: 'fluidClassID', fieldType: 'numeric' },
  fluidClass: { field: 'fluidClass', fieldType: 'text', label: 'Brand Name' },
  fluidClassName: { field: 'fluidClassName', fieldType: 'text', label: 'Brand Name' }
};
